import { render, staticRenderFns } from "./FormSenha.vue?vue&type=template&id=6db366e2&scoped=true&"
import script from "./FormSenha.vue?vue&type=script&lang=js&"
export * from "./FormSenha.vue?vue&type=script&lang=js&"
import style0 from "./FormSenha.vue?vue&type=style&index=0&id=6db366e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db366e2",
  null
  
)

export default component.exports